import React, { JSX } from "react";
import { Link } from "react-router";
import { useIsSmallScreen } from "./App";

import { CANTICLE_TONES, getCanticleTitle } from "./chants/Canticle";
import { Heading } from "./pages/home/Heading";
import { PrayButton } from "./pages/home/PrayButton";
import { Padding } from "./shared-components/Padding";
import { RUBRIC_COLOR } from "./tokens";

const getFeriaTitle = (month: number, date: number) => {
    if (month === 12) {
        if (date === 17) return "O Sapientia";
        if (date === 18) return "O Adonai";
        if (date === 19) return "O Radix Jesse";
        if (date === 20) return "O Clavis David";
        if (date === 21) return "O Oriens";
        if (date === 22) return "O Rex Gentium";
        if (date === 23) return "O Emmanuel";
    }

    return "Feria";
};

export const NewHome: React.FC<{}> = () => {
    return (
        <div
            style={{
                paddingTop: useIsSmallScreen() ? 8 : 48,
                paddingBottom: 48,
            }}
        >
            <Padding onlySides>
                <div
                    style={{
                        paddingTop: 24,
                        fontWeight: "bold",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        fontSize: "140%",
                    }}
                >
                    <div>Sing</div>
                    <div style={{ color: RUBRIC_COLOR }}>The</div>
                    <div>Office</div>
                </div>
                <div
                    style={{
                        color: RUBRIC_COLOR,
                        textAlign: "center",
                        fontWeight: "bold",
                    }}
                >
                    First Edition
                </div>
                <Heading
                    text="Pray Now"
                    rightItem={
                        <Link
                            style={{
                                textDecoration: "underline",
                                fontSize: 16,
                                paddingRight: 4,
                            }}
                            to="/settings"
                        >
                            Settings
                        </Link>
                    }
                />
                <div
                    style={{
                        display: "flex",
                        flexDirection: useIsSmallScreen() ? "column" : "row",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <PrayButton
                        link={"/pray/today/mattins"}
                        title="Mattins"
                        subtitle="Morning Prayer"
                    />
                    <PrayButton
                        link={"/pray/today/evensong"}
                        title="Evensong"
                        subtitle="Evening Prayer"
                    />
                    <PrayButton
                        link={"/pray/today/compline"}
                        title="Compline"
                        subtitle="Night Prayer"
                    />
                </div>

                <Heading text="Psalms by Number" />
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                    }}
                >
                    {(() => {
                        const allPsalms: JSX.Element[] = [];
                        for (let i = 1; i <= 150; i++) {
                            allPsalms.push(
                                <>
                                    <Link
                                        style={{
                                            padding: 4,
                                            width: 24,
                                            fontWeight: "bold",
                                            textAlign: "center",
                                        }}
                                        to={`/psalm/${i}`}
                                    >
                                        {i}
                                    </Link>{" "}
                                </>
                            );
                        }
                        return allPsalms;
                    })()}
                </div>

                <Heading text="Canticles" />
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                    }}
                >
                    {Object.entries(CANTICLE_TONES).map(
                        ([canticleId, tones]) => {
                            return (
                                <div
                                    style={{
                                        width: 240,
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        paddingTop: 16,
                                    }}
                                >
                                    <div style={{ fontWeight: "bold" }}>
                                        {getCanticleTitle(canticleId)}
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                        }}
                                    >
                                        <div
                                            style={{
                                                paddingLeft: 6,
                                                paddingRight: 6,
                                            }}
                                        >
                                            Tone
                                        </div>
                                        {tones.map((tone, toneIndex) => {
                                            if (
                                                canticleId ===
                                                    "pascha nostrum" &&
                                                toneIndex > 0
                                            ) {
                                                return <></>;
                                            }

                                            return (
                                                <Link
                                                    style={{
                                                        paddingLeft: 6,
                                                        paddingRight: 6,
                                                        fontWeight: "bold",
                                                        textAlign: "center",
                                                    }}
                                                    to={`/canticle/${canticleId.replace(
                                                        / /g,
                                                        "-"
                                                    )}/${
                                                        tone ===
                                                        "Tonus Peregrinus A"
                                                            ? "tpa"
                                                            : tone
                                                    }`}
                                                >
                                                    {tone ===
                                                    "Tonus Peregrinus A"
                                                        ? "T.P. A"
                                                        : tone}
                                                </Link>
                                            );
                                        })}
                                    </div>
                                </div>
                            );
                        }
                    )}
                </div>
            </Padding>
        </div>
    );
};
